export default class ConnectorResult {
    attributes = {};
    res = {};
    constructor(attributes, res) {
        this.attributes = attributes;
        this.res = res;
    }
}
//# sourceMappingURL=connectorResult.js.map